module.exports = __webpack_public_path__ + "images/emoji/low_brightness.0309915cd3c26a8c0a4d.png";